import { localiseTerms } from '../utils/markets'

// opts (UAE / Malaysia only): { market, label } - the sentence uses the
// choice's display label and the market's terms ("AC units"), so ops read
// the customer's wording. The answer itself is stored separately under its
// question code, unchanged. Singapore passes no opts.
export const criteriaSentence = (questionCode, requestType, criteria, opts = {}) => {
    let criteriaPhrase = ""

    switch(requestType) {
        case "Aircon Services":
            switch(questionCode) {
                case "1": 
                    if(criteria.includes("General servicing for cleaning")){
                      criteria = "General servicing for cleaning"
                    }
                    if(criteria.includes("Aircon repair")){
                      criteria = "Aircon repair"
                    }
                    criteriaPhrase = "Type of service - " + criteria
                    break
                case "2": 
                    criteriaPhrase = "Number of aircon units to be serviced - " + criteria
                    break
                case "211":
                    criteriaPhrase = "Total aircon units - " + criteria
                    break
                case "3":
                    criteriaPhrase = criteria
                    break
                case "4":
                    criteriaPhrase = "Problem - " + criteria
                  break
                case "5":
                    criteriaPhrase = "Total condenser units - " + criteria
                  break
                case "51":
                    criteriaPhrase = "Type of condenser cleaning - " + criteria
                  break
                case "21":
                    criteriaPhrase = "Frequency of service - " + criteria
                    break
                case "22":
                    criteriaPhrase = "Quantity of gas for refill - " + criteria
                    break
                case "23":
                    criteriaPhrase = "Annual package type - " + criteria
                    break
                case "24":
                    criteriaPhrase = "Mount type - " + criteria
                    break		 
                case "25":                    
                    criteriaPhrase = "Gas refill needed - " + criteria
                    break	
                case "26":
                    criteriaPhrase = "Gas type - " + criteria
                    break 
                case "27":
                    criteriaPhrase = "Number of condensers for gas refill - " + criteria
                    break 
                default:
                    criteriaPhrase = criteria
            }
            break

        case "Beauty Services":
            switch(questionCode) {
                case "1":
                  criteriaPhrase = "Type of beauty service requested - " + criteria;
                  break
                case "2":
                  criteriaPhrase = "Frequency of service needed - " + criteria;
                  break
                case "3":
                  criteriaPhrase = "Located at " + document.getElementById('searchLocationField').value;
                  break
                default:
                  criteriaPhrase = criteria
            }
            break
        case "Domestic Services":
            switch(questionCode) {
                case "0":
                  criteriaPhrase = "Type of service - " + criteria;
                  break
                case "1":
                    criteriaPhrase = "Type of helper - " + criteria;
                    break
                case "11":
                  if(criteria.includes("Flexible package")){
                    criteria = "Flexible package";
                  } 
                  criteriaPhrase = "Frequency of service - " + criteria;
                  break
                case "112":
                  criteriaPhrase = "Selected day/s - " + criteria;
                  break
                case "1121":
                  criteriaPhrase = "Number of weeks - " + criteria;
                  break
                case "11211":
                  criteriaPhrase = "Total weeks - " + criteria;
                  break                
                case "113":
                  criteriaPhrase = "Number of services - " + criteria;
                  break
                case "1131":
                  criteriaPhrase = "Total services - " + criteria;
                  break
                case "2":
                  criteriaPhrase = "Type of residential unit - " + criteria;
                  break
                case "21":
                  criteriaPhrase = "Total floor size in Sqft - " + criteria;
                  break
                case "3":
                  criteriaPhrase = "Length of each service in hours - " + criteria;
                  break                  
                default:
                  criteriaPhrase = criteria
            }
            break          
        
        case "Event Planning":
            switch(questionCode) {
                case "1":
                  criteriaPhrase = "I need an event planner for - " + criteria;
                  break
                case "2":
                  criteriaPhrase = "Date/s - " + criteria;
                  break
                case "3":
                  criteriaPhrase = "Approximate number of attendees - " + criteria;
                  break
                case "4":
                  criteriaPhrase = "Located at " + document.getElementById('searchLocationField').value;
                  break
                case "5":
                  criteriaPhrase = "My budget is " + criteria;
                  break		
                default:
                  criteriaPhrase = criteria		 
            }
            break
        
        case "Financial":
            switch(questionCode) {
                case "1":
                  if(criteria === "Get a free consultation"){
                      criteriaPhrase = "Beginner - I am looking for a financial assessment";
                  } else {
                      criteriaPhrase = "Intermediate - I am aware of what I might be looking for";
                  }
                  break
                case "11":
                  criteriaPhrase = "I am looking for - " + criteria;
                  break
                case "12":
                  criteriaPhrase = "Tenure of investment - " + criteria;
                  break
                case "2":
                    criteriaPhrase = "Annual Income " + criteria;
                    break
                case "3":
                    criteriaPhrase = "Meeting place - " + criteria;
                    break
                case "10":
                  criteriaPhrase = "Age group " + criteria;
                  break
                default:
                  criteriaPhrase = criteria	
            }	
            break	
        
        case "Fitness Trainer":
            switch(questionCode) {
                case "1":
                    criteriaPhrase = "My fitness goal is to " + criteria;
                    break
                case "2":
                    criteriaPhrase = "Current body weight - " + criteria;
                    break
                case "4":
                    criteriaPhrase = "Gender preference for the trainer - " + criteria;
                    break                
                case "5":
                    criteriaPhrase = "Personal training at " + criteria;
                    break  
                case "6":
                    criteriaPhrase = "My preferred time for work-out is " + criteria;
                    break 
                case "7":
                    criteriaPhrase = criteria;
                    break	
                case "8":
                    criteriaPhrase = criteria;
                    break	
                default:
                    criteriaPhrase = criteria		 
            }
            break

        case "Food Catering":
            switch(questionCode) {
                case "1":
                  criteriaPhrase = "Cuisine preference - " + criteria;
                  break
                case "2":
                  criteriaPhrase = "Number of pax - " + criteria;
                  break
                case "3":
                  criteriaPhrase = "Dietary restrictions - " + criteria;
                  break
                case "4":
                  criteriaPhrase = "Deliver to " + document.getElementById('searchLocationField').value;
                  break		
                default:
                  criteriaPhrase = criteria		 
            }			 
            break

        case "Housing":
            switch(questionCode) {
                case "1":
                  criteriaPhrase = "I want to " + criteria + " a property"; 
                  break
                case "2":
                  criteriaPhrase = criteria; 
                  break
                case "3":
                  criteriaPhrase = "Located at " + document.getElementById('searchLocationField').value;
                  break			 
                case "4":
                  criteriaPhrase = "I want " + criteria + " bedroom/s"; 
                  break
                case "5":
                  criteriaPhrase = "I need a minimum floor size of " + criteria +" Sqft" ; 
                  break
                case "6":
                  criteriaPhrase = "My max budget is " + criteria;
                  break
                default:
                  criteriaPhrase = criteria
            }	
            break

        case "Interior Designing":
            switch(questionCode) {
                case "1":
                  criteriaPhrase = "Floor size of my house is - " + criteria;
                  break
                case "2":
                  criteriaPhrase = "My budget is " + criteria;
                  break
                default:
                  criteriaPhrase = criteria			 
            }
            break
              
        case "Handyman Services":
            switch(questionCode) {
                case "1":
                  criteriaPhrase = "Handyman service type - " + criteria;
                  break	
                case "5":
                  criteriaPhrase = "Number of unit/s - " + criteria;
                  break
                default:
                  criteriaPhrase = criteria	 
            }
            break
      }  

      if (opts.label && opts.label !== criteria && typeof criteriaPhrase === 'string') {
          const at = criteriaPhrase.lastIndexOf(criteria)
          if (at >= 0) criteriaPhrase = criteriaPhrase.slice(0, at) + opts.label + criteriaPhrase.slice(at + criteria.length)
      }
      return opts.market ? localiseTerms(criteriaPhrase, opts.market) : criteriaPhrase;   
    
  }